<template>
  <div class="index">
    <div class="time">{{ time }}</div>
    <disks :disks="disks"></disks>
  </div>
</template>

<script>
import moment from "moment";
import { send } from ".././../socket/index";
import disks from "../../components/disks";

export default {
  name: "Page",
  components: { disks },
  data() {
    return {
      active: 0,
      disks: [],
      time: "",
    };
  },
  async mounted() {
    try {
      let res = await this.$myRequest({
        url: "/getHistoryDiskListReq",
        method: "post",
        data: {
          id: this.$route.params.historyId,
        },
      });
      res = res.data;
      this.disks = res.data.disks;
      this.time = moment(res.data.time).format(
        "脉动测试结果生成时间：YYYY-MM-DD HH:mm:ss"
      );
    } catch (err) {
      console.log(err);
    }
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
